import { useCookies } from '@/app/cookie-provider';
import PopupBanner from '@/components/sections/builder/elements/body/popup-maker/component/popup-banner';
import { PopupMakerElementDataType } from '@/components/sections/builder/elements/body/popup-maker/type';
import { ElementProps } from '@/components/sections/builder/types';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import Cookies from 'js-cookie';

export default function ElementContentPopupMaker({ element, preview, elements }: ElementProps) {
  const query = useSearchParams();
  const themeId = query.get('theme_id') || '';
  const { restrictAge } = useCookies();

  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isOpenPreview, setIsOpenPreview] = React.useState<boolean>(false);
  const [ageConfirmed, setAgeConfirmed] = React.useState<string | undefined>(() => {
    return Cookies.get('ageRestrictConfirm');
  });

  const content = element.data as PopupMakerElementDataType;
  const childs = element.childs || [];
  const typeElement = element.type;

  React.useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (typeof event.data.popupMakerPreview === 'boolean') {
        setIsOpenPreview(event.data.popupMakerPreview);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  React.useEffect(() => {
    const shouldDisableScroll = preview ? isOpenPreview : isOpen;
    if (shouldDisableScroll) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [isOpen, isOpenPreview, preview]);

  React.useEffect(() => {
    const handleAgeConfirmed = () => {
      const confirmed = Cookies.get('ageRestrictConfirm');
      setAgeConfirmed(confirmed);
    };

    window.addEventListener('ageConfirmed', handleAgeConfirmed);
    return () => window.removeEventListener('ageConfirmed', handleAgeConfirmed);
  }, []);

  React.useEffect(() => {
    if (restrictAge === true) {
      setIsOpen(ageConfirmed === 'true');
    } else if (restrictAge === false) {
      setIsOpen(true);
    }
  }, [restrictAge, ageConfirmed]);

  return (
    <PopupBanner
      typeElement={typeElement}
      isOpen={preview ? isOpenPreview : isOpen}
      content={content}
      setIsOpen={preview ? setIsOpenPreview : setIsOpen}
      preview={preview}
      childs={childs}
      themeId={themeId}
      elements={elements}
    />
  );
}
